import React from 'react';
import PropTypes from 'prop-types';
import { StaticImage } from 'gatsby-plugin-image';

import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

function SEO({ title, description, lang, meta, keywords, image, image_alt, noIndex = false }) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={(data) => {
        const metaDescription = description || (data.site && data.site.description) || '';
        const siteTitle = title || (data.site && data.site.title) || '';

        const ogImageMeta =
          image && image_alt
            ? [
                {
                  name: 'og:image',
                  content: `https://foundryfivetype.com/${image.asset.localFile.childImageSharp.fixed.src}`,
                },
                {
                  name: 'og:image:width',
                  content: image.asset.localFile.childImageSharp.fixed.width,
                },
                {
                  name: 'og:image:height',
                  content: image.asset.localFile.childImageSharp.fixed.height,
                },
                {
                  name: 'og:image:alt',
                  content: image_alt,
                },
                {
                  name: 'twitter:image',
                  content: `https://foundryfivetype.com/${image.asset.localFile.childImageSharp.fixed.src}`,
                },
              ]
            : [];

        const allMeta = noIndex
          ? [
              {
                name: 'robots',
                content: noIndex ? 'noindex,nofollow' : 'index,follow',
              },
              {
                name: 'googlebot',
                content: noIndex ? 'noindex,nofollow' : 'index,follow',
              },
            ]
          : [
              {
                name: 'description',
                content: metaDescription,
              },
              {
                name: 'og:site_name',
                content: 'Foundry Five Type',
              },
              {
                name: 'og:title',
                content: siteTitle,
              },
              {
                name: 'og:description',
                content: metaDescription,
              },
              {
                name: 'og:type',
                content: 'website',
              },
              {
                name: 'og:locale',
                content: 'en_GB',
              },
              {
                name: 'twitter:card',
                content: 'summary_large_image',
              },
              {
                name: 'twitter:site',
                content: '@foundryfive',
              },
              {
                name: 'twitter:creator',
                content: '@foundryfive',
              },
              {
                name: 'twitter:title',
                content: siteTitle,
              },
              {
                name: 'twitter:description',
                content: metaDescription,
              },
              ...ogImageMeta,
            ];

        return (
          <>
            <Helmet htmlAttributes={{ lang }} title={siteTitle} meta={allMeta} />
          </>
        );
      }}
    />
  );
}

SEO.defaultProps = {
  lang: 'en',
  meta: [],
  keywords: [],
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
};

export default SEO;

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site: sanitySiteSettings(_id: { eq: "siteSettings" }) {
      title
      description
      # keywords
    }
  }
`;
